import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface PrinterDialogData {
  title: string;
  description: string;
  cluster: string;
  laneConfig: any;
  okButtonText: string;
}

@Component({
  selector: 'app-printer-dialog',
  templateUrl: './printer.dialog.component.html',
})
export class PrinterDialogComponent {
  public selectedValue: any;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: PrinterDialogData,
    public dialogRef: MatDialogRef<PrinterDialogComponent>
  ) {}

  close(value: any) {
    this.dialogRef.close(value);
  }
}
